var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dataStatistics"},[_vm._m(0),_c('div',{staticClass:"cont-box2"},[_c('chartLine',{attrs:{"chartData":_vm.chartData,"height":"267px"}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title-box"},[_c('img',{staticClass:"cion",attrs:{"src":require("@/assets/home/dateLeft-icon.png")}}),_c('span',[_vm._v("游客区域")])])
}]

export { render, staticRenderFns }